import { SVG_ENUM } from "enums";
import React, { useState } from "react";
import { Button, SVG } from "shared";
import "./DashboardHeader.scss";
import { FiltersModal } from "features/order";
import { useGetControls, useToggleBot } from "hooks/controls";

const DashboardHeader: React.FC = () => {
  const { data } = useGetControls();
  const { mutate: toggleBot } = useToggleBot();
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <header className="dashboard-header">
      <FiltersModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <div className="dashboard-header__container">
        <div className="dashboard-header__logo">
          <SVG type={SVG_ENUM.LOGO_WITHOUT_TEXT} />
        </div>
        <div className="dashboard-header__content">
          <div className="dashboard-header__content-item">
            Podjęte zlecenia (dzisiaj): <span>{data?.todayOrdersCount}</span>
          </div>

          <Button
            label="Ustawienia filtrów"
            onClick={() => setIsModalOpen(true)}
            styleType="stroke"
            svg={SVG_ENUM.FILTER}
            size="medium"
          />
          <Button
            label={data?.isLaunched ? "Zatrzymaj bota" : "Uruchom bota"}
            onClick={() => toggleBot()}
            className="button--icon-on-right"
            styleType="primary"
            svg={data?.isLaunched ? SVG_ENUM.PAUSE_CIRCLE : SVG_ENUM.PLAY_CIRCLE}
            size="medium"
          />
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
